import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { UnpaidShiftsHeader } from './UnpaidShiftsHeader'
import { UnpaidShiftsTable } from './UnpaidShiftsTable'
import { UnpaidShiftsFilters } from './UnpaidShiftsFilters/UnpaidShiftsFilters'

export const UnpaidShiftsMain = () => {
  return (
    <>
      <UnpaidShiftsHeader />
      <Box margin={3}>
        <Text fontWeight="bold" color="warning" marginBottom={3}>
          NOTE: Actual earnings may differ from expected earnings due to bonuses
          or other adjustments.
        </Text>
        <Text fontWeight="bold" color="warning" marginBottom={3}>
          NOTE: Employer cancelled shifts are also not included yet.
        </Text>
        <Flex justifyContent="left" alignItems="center" mb={3}>
          <UnpaidShiftsFilters />
        </Flex>
        <UnpaidShiftsTable />
      </Box>
    </>
  )
}
